'use client'

import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  useDisclosure,
  useColorMode,
  Image,
} from '@chakra-ui/react'
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons'

import { MoonIcon, SunIcon } from '@chakra-ui/icons'
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';
import DuelyLogo from '../../assets/duely-logo-light.png'


const Logo = (props) => {
  return (
    <svg {...props} width="101.40000000000003" height="34.3960851470911" viewBox="0 0 370 96.22957524769234" className="looka-1j8o68f">
      <defs id="SvgjsDefs6434"><linearGradient id="SvgjsLinearGradient6439">
        <stop id="SvgjsStop6440" stopColor="#ee2a7b" offset="0"></stop>
        <stop id="SvgjsStop6441" stopColor="#ff7db8" offset="1"></stop>
      </linearGradient><linearGradient id="SvgjsLinearGradient6442">
          <stop id="SvgjsStop6443" stopColor="#ee2a7b" offset="0"></stop>
          <stop id="SvgjsStop6444" stopColor="#ff7db8" offset="1"></stop>
        </linearGradient>
      </defs>
      <g id="SvgjsG6435" featurekey="symbolFeature-0" transform="matrix(1.0994643097705796,0,0,1.0994643097705796,-5.5909050264221385,-9.116640419841827)" fill="url(#SvgjsLinearGradient6439)">
        <g xmlns="http://www.w3.org/2000/svg">
          <path d="M26.09,25.26c0.78,0,1.41,0.65,1.41,1.44c0,0.8-0.63,1.44-1.41,1.44c-0.78,0-1.41-0.65-1.41-1.44   C24.68,25.9,25.31,25.26,26.09,25.26z M28.1,91.26c1.28-0.84,2.82-1.67,4.25-2.439l1.01-0.541c0.33-0.18,0.63-0.369,0.9-0.579   c0.79-0.601,1.23-1.25,1.34-1.94c0.12-0.76-0.11-1.65-0.65-2.65c-0.17-0.31-0.37-0.629-0.61-0.969c-1.1-0.271-2.12-0.33-2.99-0.141   c-0.8,0.18-1.47,0.58-1.94,1.26c-0.49,0.7-0.86,2.52-1.08,4.49c-0.14,1.221-0.22,2.46-0.24,3.51H28.1z M33.77,91.46   c-2.38,1.28-5.15,2.771-5.61,3.56l-0.04,0.07c-0.39,0.65-1.2,0.9-1.88,0.6l-0.02-0.01h-0.01l-0.02-0.01l-0.02-0.01   c-0.35-0.18-0.64-0.49-0.76-0.9c-0.35-1.14-0.38-4.38-0.05-7.34c0.27-2.391,0.8-4.71,1.61-5.88c0.16-0.22,0.32-0.431,0.5-0.63   C14.43,83.1,7.45,87.971,7.41,88c-0.68,0.46-1.61,0.279-2.07-0.4s-0.28-1.609,0.4-2.07C5.81,85.49,21.08,74.82,48.47,77.29v-1.95   C41.2,74.41,33.8,70.8,28.09,65.48c-6.17-5.75-10.4-13.521-10.4-22.09c0-0.82,0.03-1.64,0.1-2.46c0.06-0.74,0.15-1.49,0.27-2.25   c-0.08-1.01-0.19-2.6-0.23-4.53h-2.19c-0.83,0-1.5-0.67-1.5-1.5v-0.06l0,0V32.5v-0.07v-0.02h-0.01c0-1.76,0.73-3.35,1.9-4.5   c0.59-0.57,1.28-1.04,2.05-1.36c0.15-1.52,0.38-3.02,0.71-4.44C20.59,14.47,32.86,9,34.11,8.46c0.12-0.06,0.26-0.11,0.4-0.14   c0.81-0.16,1.6,0.38,1.75,1.19c0.01,0.05,3.33,17.15,4.51,19.81c1.01,2.27,2.25,3.48,2.48,3.69c0.17,0.14,0.31,0.33,0.41,0.53   l35.27,21.601c0.07,0.039,0.131,0.08,0.19,0.129l7.69,4.48c0.709,0.41,0.959,1.33,0.539,2.04c-0.14,0.239-0.33,0.42-0.55,0.55l0,0   c-0.649,0.37-1.35,0.73-2.079,1.08l4.439,3.221l0,0c0.52,0.379,0.76,1.069,0.529,1.709c-2.34,6.51-11.42,5.771-11.449,5.771l0,0   c-0.58-0.04-1.1-0.42-1.311-1l-2.189-6.19c-0.84,0.221-1.66,0.43-2.471,0.61c-0.069,0.2-0.189,0.39-0.35,0.55   c-2.189,2.221-4.811,4.08-8.08,5.391c-3.24,1.299-7.08,2.049-11.75,2.049c-0.23,0-0.46,0-0.699-0.01v2.03   c12.389,1.5,27.1,5.69,43.85,14.58c0.73,0.38,1.01,1.29,0.63,2.021c-0.38,0.729-1.29,1.01-2.021,0.629   C70.17,82.21,50.8,79.24,36.45,79.91c0.43,0.57,0.8,1.14,1.1,1.71c0.87,1.59,1.21,3.11,0.98,4.54c-0.23,1.49-1.05,2.79-2.49,3.88   c-0.37,0.28-0.8,0.55-1.28,0.81c-0.7,0.381-0.88,0.48-1.03,0.561L33.77,91.46z M77.48,57.811c-0.08-0.051-0.16-0.101-0.23-0.17   l-1.79-1.101L41.53,35.76c-0.35-0.21-0.58-0.55-0.67-0.91c-0.65-0.68-1.86-2.14-2.82-4.3C37,28.19,34.62,16.56,33.7,11.96   c-3.38,1.66-10.8,5.81-11.98,10.84c-0.22,0.94-0.39,1.92-0.52,2.92c0.47,0.03,1.04,0.09,1.66,0.18c0.18-0.59,0.52-1.12,0.98-1.54   c0.65-0.59,1.54-0.95,2.51-0.95c0.97,0,1.86,0.36,2.51,0.95c0.69,0.62,1.12,1.5,1.12,2.47c0,0.97-0.43,1.84-1.12,2.47   c-0.24,0.21-0.51,0.4-0.8,0.55c0.16,3.17-1.79,8.48-7.05,9.42c-0.09,0.61-0.17,1.24-0.22,1.89c-0.06,0.72-0.09,1.47-0.09,2.22   c0,7.67,3.84,14.681,9.44,19.899C36.28,69,44.5,72.57,52.13,72.57c4.271,0,7.75-0.67,10.63-1.82c1.45-0.58,2.75-1.29,3.94-2.1   c-1.421,0.209-2.58,0.31-3.341,0.31c-3.779,0-7.34-0.95-10.469-2.64c-3.241-1.74-6.011-4.28-8.071-7.35   c-0.17-0.261-0.32-0.48-0.44-0.681c-0.16-0.25-0.3-0.49-0.42-0.7c-0.41-0.72-0.16-1.63,0.56-2.04c0.72-0.409,1.63-0.159,2.04,0.56   c0.13,0.23,0.25,0.431,0.36,0.601c0.15,0.24,0.27,0.44,0.38,0.601c0.12,0.18,0.24,0.359,0.37,0.529c1.75,2.43,4.01,4.43,6.63,5.85   c2.7,1.461,5.78,2.281,9.05,2.281c0.74,0,1.9-0.121,3.34-0.341c2.311-0.36,5.32-0.989,8.431-1.86l0.14-0.039l0.04-0.01l0.05-0.011   l0.03-0.01l0.021-0.011l0.05-0.01l0.05-0.01h0.01l0.04-0.01l0.05-0.01l0.041-0.01h0.01l0.05-0.011l0.05-0.01h0.02l0.03-0.011   l0.05-0.01l0.041-0.01h0.01c1.779-0.52,3.57-1.119,5.24-1.79c0.029-0.01,0.06-0.021,0.09-0.04c0.43-0.17,0.84-0.35,1.25-0.529   c0.16-0.07,0.31-0.141,0.459-0.211l-1.02-0.59l-4.439-2.58V57.811z M81.51,64.83c-1.26,0.48-2.57,0.92-3.869,1.33l1.779,5.05   c1.74-0.03,5.359-0.39,6.971-2.83l-4.881-3.54V64.83z">
          </path>
        </g></g>
      <g id="SvgjsG6436" featurekey="nameFeature-0" transform="matrix(2.1145403559200933,0,0,2.1145403559200933,115.77091928815982,-12.558613641573018)" fill="url(#SvgjsLinearGradient6442)">
        <path d="M2 12.559999999999999 l10.28 0 c8.6 0 13.8 5.92 13.8 13.64 c0 7.52 -4.88 13.32 -13.08 13.64 l-11 0 l0 -27.28 z M12.28 35.92 c6.24 0 9.32 -3.96 9.32 -9.72 c0 -5.72 -3.08 -9.68 -9.32 -9.68 l-5.96 0 l0 19.4 l5.96 0 z M46.943 12.559999999999999 l4.32 0 l0 15.44 c0 7.72 -2.84 12.2 -10.8 12.2 c-7.84 0 -10.76 -4.52 -10.76 -12.24 l0 -15.4 l4.32 0 l0 16.24 c0 3.56 1.12 7.48 6.44 7.48 c5.44 0 6.48 -3.88 6.48 -7.48 l0 -16.24 z M76.486 38.6 c3.68 1.6 6.84 2.12 9.44 2.12 c2.52 0 4.44 -0.52 5.8 -1.04 l0 4.04 c-1.56 0.48 -3.56 0.84 -5.92 0.84 c-3 0 -6.68 -0.6 -10.84 -2.4 c-4.28 -1.84 -8.56 -2.36 -12 -2.36 c-4.32 0 -7.32 0.8 -7.32 0.8 l0 -28.04 l18.96 0 l0 3.96 l-14.64 0 l0 7.52 l13.2 0 l0 3.96 l-13.2 0 l0 8.04 c0.96 -0.08 2.04 -0.12 3.2 -0.12 c3.76 0 8.36 0.56 13.32 2.68 z M81.926 30.880000000000003 l9.8 0 l0 3.96 l-14.12 0 l0 -22.28 l4.32 0 l0 18.32 z M115.149 12.559999999999999 l5.08 0 l-11.2 16.52 l0 10.76 l-4.28 0 l0 -10.72 l-11.2 -16.56 l5.08 0 l8.28 12.2 z">

        </path>
      </g>
    </svg>
  )
}


export default function WithSubnavigation() {

  const { currentUser, signInWithGoogle, signOut } = useAuth();
  let navigate = useNavigate();

  const { isOpen, onToggle } = useDisclosure()
  const { colorMode, toggleColorMode } = useColorMode()

  return (
    <Box>
      <Flex
        bg={useColorModeValue('white', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}>
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}>
          <IconButton
            onClick={onToggle}
            icon={isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />}
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'space-evenly' }} paddingRight={'20px'}>
          {/* <Text
            textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
            fontFamily={'heading'}
            color={useColorModeValue('gray.800', 'white')}>
            Logo
          </Text> */}
          <Logo />

          <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
            <DesktopNav />
          </Flex>
          <Button onClick={toggleColorMode} alignSelf={'center'}>
            {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
          </Button>
        </Flex>

        {
          !currentUser && (
            <Stack
              flex={{ base: 1, md: 0 }}
              justify={'flex-end'}
              direction={'row'}
              spacing={6}>
              <Button
                as={'a'}
                display={{ base: 'none', md: 'inline-flex' }}
                fontSize={'sm'}
                fontWeight={600}
                color={'white'}
                bg={'green.400'}
                _hover={{
                  bg: 'green.300',
                }}
                onClick={() => navigate('/auth', { replace: true })}>
                Sign In
              </Button>
            </Stack>
          )
        }
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  )
}

const DesktopNav = () => {
  const linkColor = useColorModeValue('#ee2a7b', 'gray.200')
  const linkHoverColor = useColorModeValue('#ff7db8', 'white')
  const popoverContentBgColor = useColorModeValue('white', 'gray.800')

  return (
    <Stack direction={'row'} alignItems={'right'} spacing={4}>
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Box
                as="a"
                p={2}
                href={navItem.href ?? '#'}
                fontSize={'sm'}
                fontWeight={800}
                color={linkColor}
                _hover={{
                  textDecoration: 'none',
                  color: linkHoverColor,
                }}>
                {navItem.label}
              </Box>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={4}
                rounded={'xl'}
                minW={'sm'}>
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  )
}

const DesktopSubNav = ({ label, href, subLabel }) => {
  return (
    <Box
      as="a"
      href={href}
      role={'group'}
      display={'block'}
      p={2}
      rounded={'md'}
      _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
      <Stack direction={'row'} align={'center'}>
        <Box>
          <Text
            transition={'all .3s ease'}
            _groupHover={{ color: 'pink.400' }}
            fontWeight={500}>
            {label}
          </Text>
          <Text fontSize={'sm'}>{subLabel}</Text>
        </Box>
        <Flex
          transition={'all .3s ease'}
          transform={'translateX(-10px)'}
          opacity={0}
          _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
          justify={'flex-end'}
          align={'center'}
          flex={1}>
          <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
        </Flex>
      </Stack>
    </Box>
  )
}

const MobileNav = () => {
  return (
    <Stack bg={useColorModeValue('white', 'gray.800')} p={4} display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  )
}

const MobileNavItem = ({ label, children, href }) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Box
        py={2}
        as="a"
        href={href ?? '#'}
        justifyContent="space-between"
        alignItems="center"
        _hover={{
          textDecoration: 'none',
        }}>
        <Text fontWeight={600} color={useColorModeValue('gray.600', 'gray.200')}>
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Box>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children.map((child) => (
              <Box as="a" key={child.label} py={2} href={child.href}>
                {child.label}
              </Box>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  )
}

// interface NavItem {
//   label: string
//   subLabel?: string
//   children?: Array<NavItem>
//   href?: string
// }

const NAV_ITEMS = [
  {
    label: 'Contact',
    href: '/contact',
  },
]